import { notification } from 'antd';
import i18n from '../i18n';
import {EventList} from './constraints'
import { TYPES } from "./types";
const {paginationProps, FilterVideos, showDivsConditions, loadingDeleteShowVideo} = EventList()
// Extract filter parameter from the URL
const urlParams = new URLSearchParams(window.location.search); 

const filter = urlParams.get('filter'); // Get the value of the 'filter' query parameter
const INITIALSTATE = {
  ListVideos: [],
  pagination: paginationProps(),
  FilterVideos: FilterVideos(),
  showDivsCondition: showDivsConditions(),
  lang: localStorage.getItem("i18nextLng")
    ? localStorage.getItem("i18nextLng")
    : "fr",
  loadingDelete: loadingDeleteShowVideo(),
  logo: "",
  urlLogo: "",
  isCropped: true,
  setLoader: false,
  selectedYTB:false,
  links:"",
  deleteMultiEvents:false,
  onConfirmMultiDelete: null,
  currentStatus: filter ?? "live",
  indexationEvents: false,
  eventDelay:null,
  liveStreamStatus:-1,
  actionIndexation:null,
  eventsEnded:[],
  isSDIstation:false
 };
 const shownEventNotifications = new Set(); // Format: `${eventId}_started` or `${eventId}_ended`

export const reducer = (state = INITIALSTATE, action) => {

    switch (action.type) {
        case "SET_ShowVideos":
            return {
                ...state,
                ListVideos: action.payload
            }
            case "CURRENT_STATUS":{
                return{
                    ...state,
                    currentStatus: action.payload
                }
            }
        case "SET_PaginationProps" :
            const {PaginationPropsNameChange, PaginationPropsValueChange} = action.payload
            return {
                ...state,
                pagination: {...state.pagination, [PaginationPropsNameChange]: PaginationPropsValueChange}
            }
        case "SET_THEMES":
            return {
                ...state,
                themes : action.payload
            }
        case "SET_SDI_station": 
         return {
                ...state,
                isSDIstation : action.payload
            }
        case "SET_FilterVideos" :
            const {FilterVideosNameChange, FilterVideosValueChange} = action.payload
            const FilterVideosOnOnchangeObj = {...state.FilterVideos, [FilterVideosNameChange]: FilterVideosValueChange}
            return {
                ...state,
                FilterVideos: FilterVideosOnOnchangeObj
            }

        case "SET_ConfirmMultiDelete":
             return {
                ...state,
                onConfirmMultiDelete : action.payload
            }

       case "SET_DeleteMultiEvents":
             return {
                ...state,
                deleteMultiEvents:  action.payload
              }

              case "SET_IndexationEvent":
                return {
                   ...state,
                   indexationEvents:  action.payload
                 }
                 case "SET_IndexationEventDelay":
                    return {
                       ...state,
                       eventDelay:  +action.payload
                     }
                     case "SET_LiveStreamStatus":
                        return {
                           ...state,
                           liveStreamStatus:  +action.payload
                         }
                         case "SET_EventEnded": {
                            const updatedListVideos = state.ListVideos.data.map(video => {
                                if (video.id === action.payload) {
                                    return { ...video, status: 1 };
                                }
                                return video;
                            });
                        
                            const key = `${action.payload}_ended`;
                            if (!shownEventNotifications.has(key)) {
                                notification.success({
                                    message: i18n.t('Message.eventStatusChanged'),
                                    description: i18n.t('Message.notifStopEvent', { id: action.payload }),
                                    duration: 2,
                                    placement: 'topRight',
                                });
                                shownEventNotifications.add(key);
                            }
                            const alreadyEnded = state.eventsEnded.includes(action.payload);

                            return {
                                ...state,
                                ListVideos: { ...state.ListVideos, data: updatedListVideos },
                                eventsEnded: alreadyEnded 
                                ? state.eventsEnded 
                                : [...state.eventsEnded, action.payload],
                            
                            };
                        }
                        
                         case "SET_EventStarted": {
                            const updatedListVideos = state.ListVideos.data.map(video => {
                                if (video.id === action.payload) {
                                    return { ...video, status: 0 };
                                }
                                return video;
                            });
                        
                            const key = `${action.payload}_started`;
                            if (!shownEventNotifications.has(key)) {
                                notification.success({
                                    message: i18n.t('Message.eventStatusChanged'),
                                    description: i18n.t('Message.notifStartEvent', { id: action.payload }),
                                    duration: 2,
                                    placement: 'topRight',
                                });
                                shownEventNotifications.add(key);
                            }
                        
                            return {
                                ...state,
                                ListVideos: { ...state.ListVideos, data: updatedListVideos },
                            };
                        }
               
                 case "SET_IndexationEventAction" :        
                            return {
                                ...state,
                                actionIndexation:  action.payload
                              }              
        case "SET_showDivsConditions":
            const {showDivsConditionsName, showDivsConditionsValue} = action.payload
            const showDivsConditionsObj = {
                ...state.showDivsCondition,
                [showDivsConditionsName]: showDivsConditionsValue
            }
            return {
                ...state,
                showDivsCondition: showDivsConditionsObj
            }
        case "CHANGE_LANG":
            return {...state, lang: action.payload}
        case "SET_LoadingDeleteShowVideo":
            const {LoadingDeleteName, LoadingDeleteValue} = action.payload
            const LoadingDeleteObj = {...state.loadingDelete, [LoadingDeleteName]: LoadingDeleteValue}
            return {
                ...state,
                loadingDelete: LoadingDeleteObj
            }
        case "UPLOAD_LOGO_THEME":
            return {
                ...state,
                logo : action.payload
            }
        case "UPLOAD_LOGO_URL":
            return {
                ...state,
                urlLogo:action.payload
            }    
        case "SET-CROPPED":
            return {
                ...state,
                isCropped:action.payload
            }
        case "SET-LOADER":
            return{
                ...state,
                setLoader:action.payload
            }
        case "SET_SELECTED_YTB":
            return {
              ...state,
              selectedYTB: action.payload,
            };  
        case "SET_LINKS":
            return {
                ...state,
                links:action.payload
            }
        case TYPES.START_EVENT_SUCCESS:{
            const updatedListVideos = state.ListVideos.data.map(video => {
                if (video.id === action.payload.id) {
                  return { ...video, status: 0 };
                }
                return video;
        });

        return {
                ...state,
                ListVideos: { ...state.ListVideos, data: updatedListVideos },
            }
        }

            
        case TYPES.STOP_EVENT_SUCCESS:
            const updatedListVideos = state.ListVideos.data.map(video => {
            if (video.id === action.payload.id) {
                      return { ...video, status: 1 };
            }
            return video;
            });
   
            return {
                    ...state,
                    ListVideos: { ...state.ListVideos, data: updatedListVideos },
            }      
            
            case TYPES.CHANGE_MODE_EVENT_SUCCESS:{
                const updatedListVideos = state.ListVideos.data.map(video => {
                if (video.id === action.payload.id) {
                          return { ...video, isStandby: !action.payload.isStandby };
                }
                return video;
                });
       
                return {
                        ...state,
                        ListVideos: { ...state.ListVideos, data: updatedListVideos },
                }  
            }
            default: {
            return state
        }

    }


}